import React, { useState, useEffect } from "react";
import "./Cart.scss";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { removeFromCart } from "../../redux/actions/cartActions";

const Cart = () => {
  const [cartProduct, setCartProduct] = useState([]);
  const [product, setProducts] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);

  const tokena = localStorage.getItem("raer_token");
  const userId = localStorage.getItem("raer_id");

  const navigate = useNavigate();

  useEffect(() => {
    if (!tokena) {
      navigate("/login");
      return;
    }
  });

  const getCartProductDetails = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getProductsInCart/${userId}`, // this is userId
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data?.products);
        console.log(response?.data?.data?.resultOfData);
        if (response?.data?.status == true) {
          setProducts(response?.data?.data?.products);
          setCartProduct(response?.data?.data?.resultOfData);
          setTotalPrice(response?.data?.data?.totalPrice);
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  useEffect(() => {
    getCartProductDetails();
  }, []);

  const handleClick = () => {
    navigate("/allProduct");
  };

  const dispatch = useDispatch();

  const removeFromCartby = (Item) => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/addToCart`,
      method: "post",
      data: {
        productId: Item.productId,
        sku: Item.sku,
        count: Item.count * -1,
        size: Item.size,
        userId: userId,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          dispatch(removeFromCart(Item.sku));
          getCartProductDetails();
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };
  //done
  const reduceValue = (Item) => {
    console.log(Item.count);
    if (Item.count == 1) {
      dispatch(removeFromCart(Item.sku));
    }
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/addToCart`,
      method: "post",
      data: {
        productId: Item?.productId,
        sku: Item?.sku,
        count: -1,
        size: Item?.size,
        userId: userId,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          getCartProductDetails();
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };
  // done
  const increasValue = (Item) => {
    if (Item.count == 0) {
      return;
    }
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/addToCart`,
      method: "post",
      data: {
        productId: Item?.productId,
        sku: Item?.sku,
        count: 1,
        size: Item?.size,
        userId: userId,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          getCartProductDetails();
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  return (
    <div>
      <div className="cart-main">
        <div className="main-boxx single-container">
          <div className="main-line">
            {product?.length > 0 ? (
              product?.map((Item, index) => {
                return (
                  <>
                    <div className="main-inner">
                      <div className="left-image">
                        <div className="img-box">
                          <img
                            className="iimmgg"
                            src={
                              cartProduct[0]?.products[index]?.productId
                                ?.image[0]
                            }
                            alt="Loding..."
                          />
                        </div>
                      </div>

                      <div className="right-info">
                        <div className="top-container">
                          <p className="item-name">
                            {" "}
                            {
                              cartProduct[0]?.products[index]?.productId
                                ?.productName
                            }{" "}
                          </p>

                          {/* delete item icon */}
                          <svg
                            width="20px"
                            height="20px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => {
                              removeFromCartby(Item);
                              window.scrollTo(0, 0);
                            }}
                          >
                            <path
                              d="M4 6H20M16 6L15.7294 5.18807C15.4671 4.40125 15.3359 4.00784 15.0927 3.71698C14.8779 3.46013 14.6021 3.26132 14.2905 3.13878C13.9376 3 13.523 3 12.6936 3H11.3064C10.477 3 10.0624 3 9.70951 3.13878C9.39792 3.26132 9.12208 3.46013 8.90729 3.71698C8.66405 4.00784 8.53292 4.40125 8.27064 5.18807L8 6M18 6V16.2C18 17.8802 18 18.7202 17.673 19.362C17.3854 19.9265 16.9265 20.3854 16.362 20.673C15.7202 21 14.8802 21 13.2 21H10.8C9.11984 21 8.27976 21 7.63803 20.673C7.07354 20.3854 6.6146 19.9265 6.32698 19.362C6 18.7202 6 17.8802 6 16.2V6M14 10V17M10 10V17"
                              stroke="#000000"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>

                        <p>Rs. {Math.ceil(Item.price)}/-</p>

                        <p>Size: {Item.size}</p>

                        <p>
                          Color:{" "}
                          {cartProduct[0]?.products[index]?.productId?.color}
                        </p>

                        <div className="bottom-container">
                          <p>
                            Total: Rs.{Math.ceil(Item.price) * Item.count}/-
                          </p>

                          <div className="below">
                            <button
                              onClick={() => {
                                reduceValue(Item);
                                window.scrollTo(0, 0);
                              }}
                              className="plusButton"
                            >
                              <i
                                class="bi bi-dash "
                                style={{ border: "none" }}
                              ></i>
                            </button>

                            <h5 className="f-bolt">{Item.count}</h5>

                            <button
                              onClick={() => {
                                increasValue(Item);
                                window.scrollTo(0, 0);
                              }}
                              className="plusButton"
                            >
                              <i
                                class="bi bi-plus"
                                style={{ border: "none" }}
                              ></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })
            ) : (
              <h4>There are no product in your cart ! </h4>
            )}
          </div>
        </div>

        <div className="right-container">
          <div className="buttons-div single-container">
            <div className="top-container">
              <div className="cart-value-container">
                <p>Cart Value</p>
                <p>Rs. {Math.ceil(totalPrice)}/-</p>
              </div>

              <div className="delivery-cost-container">
                <p>Delivery Charge</p>
                <p>FREE</p>
              </div>

              <div className="cart-text-container">
                <p>*including all applicable taxes and fees</p>
              </div>
            </div>

            <hr />

            <div className="no-pro">
              <p>Total Amount</p>
              <p>Rs. {Math.ceil(totalPrice)}/-</p>
            </div>

            <div className="cart-text-container">
              <p>
                You're almost there! Just a few more steps to go before you can
                finalize your purchase and have your items on the way to you.
              </p>
            </div>
          </div>

          <div className="button-div-cart">
            <button
              className="proceed"
              disabled={product?.length === 0 ? true : false}
              onClick={() => {
                navigate("/checkout");
                window.scrollTo(0, 0);
              }}
            >
              PROCEED TO CHECKOUT
            </button>

            <button className="continew-btn proceed shop" onClick={handleClick}>
              CONTINUE SHOPPING
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
